
import { ChatType, CopilotStudyLevel, PromptVersion } from '../enums';
import { RenderCopilotRequest } from './RenderCopilotRequest';

export class RenderChatCopilotCommand extends CustomEvent<RenderCopilotRequest> {
	constructor(
		chatType: ChatType,
		studyLevel: CopilotStudyLevel,
		element?: HTMLElement,
		contextData?: { [key: string]: string },
		promptVersion?: PromptVersion,
		studyId?: number
	) {
		const detail = { element, chatType, contextData, studyLevel, promptVersion, studyId };

		super('', { detail });
	}
}
